import { GridListSelectable, BodySmall, LayoutSpaceVertical, TruncateString } from 'breeze-intelligence-kit';
import SourceInterpretation from 'crm-source-interpretation-lib';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { PropertyValue } from './PropertyValue';
import { EMPTY_LABEL } from '../../constants';
import { useEnrichmentCredits } from '../EnrichmentCreditsProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ValueItem = ({
  fieldType,
  numberDisplayHint,
  timestamp,
  value
}) => {
  return /*#__PURE__*/_jsx(GridListSelectable.Item, {
    children: !value ? EMPTY_LABEL : /*#__PURE__*/_jsxs(LayoutSpaceVertical, {
      gap: "space-xxxs",
      children: [/*#__PURE__*/_jsx(TruncateString, {
        children: /*#__PURE__*/_jsx(PropertyValue, {
          fieldType: fieldType,
          numberDisplayHint: numberDisplayHint,
          value: value
        })
      }), timestamp && /*#__PURE__*/_jsx(BodySmall, {
        color: "light",
        children: /*#__PURE__*/_jsx(FormattedDateTime, {
          format: "short-full-date",
          type: "portalTz",
          value: new Date(timestamp)
        })
      })]
    })
  });
};
export const EnrichmentPropertiesRow = ({
  property
}) => {
  const {
    fieldType,
    label,
    name,
    numberDisplayHint,
    sourceDescription,
    sourceInstance,
    sourceLabel,
    sourceUser,
    timestamp,
    value,
    valueNew
  } = property;
  const {
    isIncludedEnrichment
  } = useEnrichmentCredits();
  return /*#__PURE__*/_jsxs(GridListSelectable.Row, {
    alignItems: "start",
    label: label,
    value: name,
    children: [/*#__PURE__*/_jsx(GridListSelectable.Item, {
      children: label
    }), /*#__PURE__*/_jsx(ValueItem, {
      fieldType: fieldType,
      numberDisplayHint: numberDisplayHint,
      timestamp: timestamp,
      value: value
    }), isIncludedEnrichment && /*#__PURE__*/_jsx(ValueItem, {
      fieldType: fieldType,
      numberDisplayHint: numberDisplayHint,
      value: valueNew || ''
    }), /*#__PURE__*/_jsx(GridListSelectable.Item, {
      children: !value ? EMPTY_LABEL : /*#__PURE__*/_jsx(SourceInterpretation, {
        description: sourceDescription,
        instance: sourceInstance,
        label: sourceLabel,
        user: sourceUser
      })
    })]
  });
};